import { render, staticRenderFns } from "./EmbedEmplacamento.vue?vue&type=template&id=5844de40&scoped=true"
import script from "./EmbedEmplacamento.vue?vue&type=script&lang=ts"
export * from "./EmbedEmplacamento.vue?vue&type=script&lang=ts"
import style0 from "./EmbedEmplacamento.vue?vue&type=style&index=0&id=5844de40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5844de40",
  null
  
)

export default component.exports